<template>
    <div>
        <div class="d-block pt-5">
            <div class="row justify-content-center">
                <div class="col-md-10">
                    <div class="d-block h2 font-bold mb-5"><i class="fa-solid fa-caret-right me-3 text-neon"></i>Masukan Nilai Rapor</div>
                        <div class="d-flex flex-wrap mb-4">
                            <button v-for="(item, index) in semesterTabs" :key="index" class="btn btn-sm btn-s-1 me-2" :class="item == semester_active ? 'btn-primary':'btn-blue-1'" type="button" v-on:click="setSemester(item)">
                                <div class="btn-s-1-inner">{{ getSemesterLabel(item) }}</div>
                            </button>
                        </div>

                        <div v-if="!isTkaActive" class="d-flex flex-wrap align-items-center justify-content-end mb-4">
                            <div class="d-block small text-muted me-auto">Isi nilai di file format. Isi "-" untuk mata pelajaran yang Off di semester tersebut, kosongkan jika tidak ingin diubah.</div>
                            <button type="button" class="btn btn-white-naked btn-sm me-2" v-on:click="downloadTemplate" :disabled="fetch_import">
                                <i class="fa-solid fa-download me-2"></i>Download Format
                            </button>
                            <button type="button" class="btn btn-white-naked btn-sm" v-on:click="$refs.importFile.click()" :disabled="fetch_import || fetch_save_score">
                                <i class="fa-solid me-2" :class="fetch_import ? 'fa-spin fa-spinner':'fa-file-import'"></i>{{ fetch_import ? 'Mengimpor...':'Import Nilai' }}
                            </button>
                            <input ref="importFile" type="file" class="d-none" accept=".xlsx,.xls" v-on:change="onImportFile">
                        </div>
                        
                        <div v-for="(itemSemester, indexSemester) in semesterTabs" :key="indexSemester" :class="itemSemester == semester_active ? 'd-block':'d-none'">
                            <div class="row" v-if="getDataSubjectByTab(itemSemester).length <= getDividerByTab(itemSemester)">
                                <div class="col-6">
                                    <div class="d-flex justify-content-end">
                                        <div class="d-block small font-bold pe-3 me-2">On/Off</div>
                                    </div>
                                    <table class="table border-0 table-sm-td table-hover">
                                        <tbody>
                                            <tr v-for="(item, index) in getDataSubjectByTab(itemSemester)" :key="index">
                                                <td class="font-bold">
                                                    <div class="block-ellipsis block-190 border-bottom">{{item.name}}</div>
                                                </td>
                                                <td>
                                                    <div class="form-group form-style-1 m-0 form-style-1-number">
                                                        <input type="text" class="form-control form-control-number" v-model="getScoreListByTab(itemSemester)[item.id].score">
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="d-flex align-items-center justify-content-end">
                                                        <div class="form-check form-switch">
                                                            <input class="form-check-input" type="checkbox" v-model="getScoreListByTab(itemSemester)[item.id].active" :checked="getScoreListByTab(itemSemester)[item.id].active == 1 ? 'checked':''" true-value="1" false-value="0">
                                                            <label class="form-check-label"></label>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div class="row" v-if="getDataSubjectByTab(itemSemester).length > getDividerByTab(itemSemester)">
                                <div class="col-6">
                                    <div class="d-flex justify-content-end">
                                        <div class="d-block small font-bold pe-3 me-2">On/Off</div>
                                    </div>
                                    <table class="table border-0 table-sm-td table-hover">
                                        <tbody>
                                            <tr v-for="(item, index) in getFirstHalfByTab(itemSemester)" :key="index">
                                                <td class="font-bold">
                                                    <div class="block-ellipsis block-190 border-bottom">{{item.name}}</div>
                                                </td>
                                                <td>
                                                    <div class="form-group form-style-1 m-0 form-style-1-number">
                                                        <input type="text" class="form-control form-control-number" v-model="getScoreListByTab(itemSemester)[item.id].score">
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="d-flex align-items-center justify-content-end">
                                                        <div class="form-check form-switch">
                                                            <input class="form-check-input" type="checkbox" v-model="getScoreListByTab(itemSemester)[item.id].active" :checked="getScoreListByTab(itemSemester)[item.id].active == 1 ? 'checked':''" true-value="1" false-value="0">
                                                            <label class="form-check-label"></label>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="col-6">
                                    <div class="d-flex justify-content-end">
                                        <div class="d-block small font-bold pe-3 me-2">On/Off</div>
                                    </div>
                                    <table class="table border-0 table-sm-td table-hover">
                                        <tbody>
                                            <tr v-for="(item, index) in getSecondHalfByTab(itemSemester)" :key="index">
                                                <td class="font-bold">
                                                    <div class="block-ellipsis block-190 border-bottom">{{item.name}}</div>
                                                </td>
                                                <td>
                                                    <div class="form-group form-style-1 m-0 form-style-1-number">
                                                        <input type="text" class="form-control form-control-number" v-model="getScoreListByTab(itemSemester)[item.id].score">
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="d-flex align-items-center justify-content-end">
                                                        <div class="form-check form-switch">
                                                            <input class="form-check-input" type="checkbox" v-model="getScoreListByTab(itemSemester)[item.id].active" :checked="getScoreListByTab(itemSemester)[item.id].active == 1 ? 'checked':''" true-value="1" false-value="0">
                                                            <label class="form-check-label"></label>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-end mt-4 pt-4 border-top mb-5">
            <button type="button" class="btn btn-white btn-lg btn-s-1 me-3" v-on:click="saveScore" :disabled="fetch_save_score">
                <div class="btn-s-1-inner">
                    <i v-if="fetch_save_score" class="fa-solid fa-spin fa-spinner fa-lg me-3"></i>
                    <i v-if="!fetch_save_score" class="fa-solid fa-save fa-lg me-3"></i>{{fetch_save_score ? 'Harap tunggu..':saveScoreButtonText}}
                </div>
            </button>
            <button v-if="!isTkaActive" type="button" class="btn btn-white btn-lg btn-s-1 me-3" v-on:click="generateScore" :disabled="fetch_generate">
                <div class="btn-s-1-inner">
                    <i v-if="fetch_generate" class="fa-solid fa-spin fa-spinner fa-lg me-3"></i>
                    <i v-if="!fetch_generate" class="fa-solid fa-bolt fa-lg me-3"></i>{{fetch_generate ? 'Harap tunggu..':'Hitung Rasionalisasi'}}
                </div>
            </button>
            <button v-if="form.generate" type="button" class="btn btn-primary btn-lg btn-s-1" v-on:click="onSubmit" :disabled="waiting">
                <div class="btn-s-1-inner">{{ waiting ? 'Menyimpan...' : 'Selanjutnya' }}<i class="fa-solid fa-arrow-right fa-lg ms-3"></i></div>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RationalizationFormScore',
    data() {
        return {
            fetch_generate : false,
            fetch_save_score : false,
            fetch_import : false,
            dataEvents : [],
            dataAchievement : [],
            form : {
                id                      : "",
                total_semester          : 5,
                score_passing_grade     : "",
                subject_list            : {},
                score_tka_list          : {},
                generate                : 0
            },
            semester_active : 1,
            dataSubject     : [],
            dataSubjectTka  : [],
            firstHalf       : [],
            secondHalf      : [],
            divider         : 5,
            firstHalfTka    : [],
            secondHalfTka   : [],
            dividerTka      : 5,
            submitted           : false,
            waiting             : false
        }
    },
    computed: {
        semesterTabs: function() {
            let tabs = [];

            for (let index = 1; index <= this.form.total_semester; index++) {
                tabs.push(index);
            }

            // Tab Nilai TKA di-hide sementara
            // tabs.push('tka');

            return tabs;
        },
        isTkaActive: function() {
            return this.semester_active === 'tka';
        },
        saveScoreButtonText: function() {
            return this.isTkaActive ? 'Simpan Nilai TKA' : 'Simpan Nilai Semester';
        }
    },
    created() {
        this.getSubject();
    },
    methods: {
        setSemester: function(params) {
            this.semester_active = params;
        },
        getSemesterLabel: function(item) {
            return item === 'tka' ? 'Nilai TKA' : `Semester ${item}`;
        },
        initializeSubjectListByKey: function(key) {
            this.form.subject_list[key] = {};

            this.dataSubject.forEach(element => {
                this.form.subject_list[key][element.id] = {
                    id : element.id,
                    score : '',
                    active : 0
                };
            });
        },
        initializeScoreTkaList: function() {
            this.form.score_tka_list = {};

            this.dataSubjectTka.forEach(element => {
                this.form.score_tka_list[element.id] = {
                    id : element.id,
                    score : '',
                    active : 0
                };
            });
        },
        getDataSubjectByTab: function(itemSemester) {
            return itemSemester === 'tka' ? this.dataSubjectTka : this.dataSubject;
        },
        getFirstHalfByTab: function(itemSemester) {
            return itemSemester === 'tka' ? this.firstHalfTka : this.firstHalf;
        },
        getSecondHalfByTab: function(itemSemester) {
            return itemSemester === 'tka' ? this.secondHalfTka : this.secondHalf;
        },
        getDividerByTab: function(itemSemester) {
            return itemSemester === 'tka' ? this.dividerTka : this.divider;
        },
        splitSubjectList: function(list, prioritizeLeft = false) {
            let divider = prioritizeLeft ? Math.ceil(list.length / 2) : Math.floor(list.length / 2);
            let useTwoColumns = list.length > divider;

            return {
                divider: divider,
                firstHalf: useTwoColumns ? list.slice(0, divider) : list,
                secondHalf: useTwoColumns ? list.slice(divider) : []
            };
        },
        getScoreListByTab: function(itemSemester) {
            return itemSemester === 'tka' ? this.form.score_tka_list : this.form.subject_list[itemSemester];
        },
        ensureSubjectListStructure: function() {
            if (this.form.subject_list === undefined || this.form.subject_list === null || typeof this.form.subject_list !== 'object') {
                this.form.subject_list = {};
            }

            for (let index = 1; index <= this.form.total_semester; index++) {
                if (this.form.subject_list[index] === undefined) {
                    this.initializeSubjectListByKey(index);
                }
            }

            if (this.form.score_tka_list === undefined || this.form.score_tka_list === null || Object.keys(this.form.score_tka_list).length === 0) {
                this.initializeScoreTkaList();
            } else {
                this.dataSubjectTka.forEach(element => {
                    if (this.form.score_tka_list[element.id] === undefined) {
                        this.form.score_tka_list[element.id] = {
                            id : element.id,
                            score : '',
                            active : 0
                        };
                    }
                });
            }
        },
        getSubject: function() {
            let uri         = process.env.VUE_APP_APIHOST+'subject/list';
            this.$http.get(uri,{
                params : {
                    limit    : 1000
                }
            }).then(res => {
                this.dataSubject    = res.data.data;
                this.dataSubjectTka = this.dataSubject.filter(item => Number(item.tka) === 1);

                let semesterSplit   = this.splitSubjectList(this.dataSubject);
                this.divider        = semesterSplit.divider;
                this.firstHalf      = semesterSplit.firstHalf;
                this.secondHalf     = semesterSplit.secondHalf;

                let tkaSplit        = this.splitSubjectList(this.dataSubjectTka, true);
                this.dividerTka     = tkaSplit.divider;
                this.firstHalfTka   = tkaSplit.firstHalf;
                this.secondHalfTka  = tkaSplit.secondHalf;

                for (let index = 1; index <= this.form.total_semester; index++) {
                    this.initializeSubjectListByKey(index);
                }

                this.initializeScoreTkaList();

                if ((this.$parent.dataRationalization.score_list !== undefined && this.$parent.dataRationalization.score_list !== null && this.$parent.dataRationalization.score_list !== "")
                    || (this.$parent.dataRationalization.score_tka_list !== undefined && this.$parent.dataRationalization.score_tka_list !== null && this.$parent.dataRationalization.score_tka_list !== "")) {
                    this.getData();
                }

                this.ensureSubjectListStructure();
            });
        },
        getData: function() {
            let datasets     = this.$parent.dataRationalization;

            for (let key in datasets) {
                if (Object.prototype.hasOwnProperty.call(datasets, key)) {
                    if(key == 'score_list') {
                        if (datasets[key] !== undefined && datasets[key] !== null && datasets[key] !== '' && typeof datasets[key] === 'object') {
                            this.form.subject_list = datasets[key];
                        }
                        continue;
                    }

                    if(key == 'score_tka_list') {
                        if (datasets[key] !== undefined && datasets[key] !== null && datasets[key] !== '' && typeof datasets[key] === 'object') {
                            this.form.score_tka_list = datasets[key];
                        }
                        continue;
                    }

                    this.form[key] = datasets[key];
                }
            }

            if ((this.form.score_tka_list === undefined || this.form.score_tka_list === null || Object.keys(this.form.score_tka_list).length === 0)
                && this.form.subject_list !== undefined && this.form.subject_list.tka !== undefined) {
                this.form.score_tka_list = this.form.subject_list.tka;
            }
        }, 
        generateScore: function() {
            this.fetch_generate = true;
            let formData = new FormData();
            formData.append('rationalization_id', this.$parent.dataRationalization.id);
            formData.append('code', this.$parent.dataRationalization.code);
            formData.append('major_one', this.$parent.dataRationalization.major_one.id);
            formData.append('major_one_name', this.$parent.dataRationalization.major_one.name);
            formData.append('major_one_group', this.$parent.dataRationalization.major_one.group_subject_id);
            formData.append('major_two', this.$parent.dataRationalization.major_two.id);
            formData.append('major_two_name', this.$parent.dataRationalization.major_two.name);
            formData.append('major_two_group', this.$parent.dataRationalization.major_two.group_subject_id);

            for (let key in this.form) {
                if(key == 'subject_list') {
                    formData.append('subject_list', JSON.stringify(this.form.subject_list));
                } else {
                    formData.append(key, this.form[key]);
                }
            }

            this.$http.post(process.env.VUE_APP_APIHOST + 'rationalization/generate-score', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(response => {
                this.fetch_generate = false;

                if (response.data.status) {
                    this.$swal({
                        icon: 'success',
                        title: 'Success',
                        text: response.data.message,
                        confirmButtonText: 'OK'
                    }).then((result) => {
                        if (result.value) {
                            this.form.generate = response.data.generate;

                            this.$parent.getDataByCode(response.data.code);
                            this.$parent.getStep();
                        }
                    });
                } else {
                    this.$swal({
                        icon: 'warning',
                        title: 'Ups!',
                        text: response.data.message,
                    });
                }
                this.waiting = false;
            })
            .catch(function () {
                this.$swal({
                    icon: 'warning',
                    title: 'Ups!',
                    text: 'Please check your internet connection.',
                });
                this.waiting = false;
                return;
            });
        },
        getSemesterColumnName: function(semester) {
            return `Semester ${semester}`;
        },
        getSemesterList: function() {
            let list = [];

            for (let semester = 1; semester <= Number(this.form.total_semester); semester++) {
                list.push(semester);
            }

            return list;
        },
        isSubjectActive: function(entry) {
            return entry !== undefined && entry !== null && Number(entry.active) === 1;
        },
        escapeHtml: function(text) {
            return String(text)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;');
        },
        getScoreEntry: function(semester, subjectId) {
            let scoreList = this.form.subject_list[semester] || {};

            return scoreList[subjectId];
        },
        // Satu sheet: baris = semua mapel, kolom = semester.
        // Sel "-" berarti switch OFF (saat download maupun import).
        downloadTemplate: async function() {
            let semesters = this.getSemesterList();
            let subjects = this.dataSubject;

            if (subjects.length === 0) {
                this.$swal({
                    icon: 'warning',
                    title: 'Ups!',
                    text: 'Data mata pelajaran belum tersedia.',
                });
                return;
            }

            const XLSX = await import('xlsx');
            let rows = [['ID', 'Mata Pelajaran'].concat(semesters.map(semester => this.getSemesterColumnName(semester)))];

            subjects.forEach(subject => {
                let row = [subject.id, subject.name];

                semesters.forEach(semester => {
                    let entry = this.getScoreEntry(semester, subject.id);

                    if (!this.isSubjectActive(entry)) {
                        row.push('-');
                        return;
                    }

                    let currentScore = entry.score;
                    let numericScore = Number(currentScore);
                    let isEmpty = currentScore === '' || currentScore === null || currentScore === undefined || !isFinite(numericScore);

                    row.push(isEmpty ? '' : numericScore);
                });

                rows.push(row);
            });

            let worksheet = XLSX.utils.aoa_to_sheet(rows);
            // Kolom ID disembunyikan, dipakai untuk mencocokkan data saat import.
            worksheet['!cols'] = [{ wch: 8, hidden: true }, { wch: 40 }].concat(semesters.map(() => ({ wch: 12 })));

            let workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Nilai Rapor');

            let code = this.$parent.dataRationalization.code || 'baru';
            XLSX.writeFile(workbook, `format-nilai-rapor-${code}.xlsx`);
        },
        onImportFile: async function(event) {
            let file = event.target.files[0];
            event.target.value = '';

            if (!file) {
                return;
            }

            this.fetch_import = true;
            let parsed = null;

            try {
                const XLSX = await import('xlsx');
                let workbook = XLSX.read(await file.arrayBuffer());
                parsed = this.parseImportWorkbook(XLSX, workbook);
            } catch (error) {
                this.fetch_import = false;
                this.$swal({
                    icon: 'warning',
                    title: 'Ups!',
                    text: 'File tidak dapat dibaca. Pastikan menggunakan file format yang sudah di-download.',
                });
                return;
            }

            this.fetch_import = false;

            if (parsed.errors.length > 0) {
                let maxShown = 10;
                let list = parsed.errors.slice(0, maxShown).map(item => `<li>${this.escapeHtml(item)}</li>`).join('');
                let more = parsed.errors.length > maxShown ? `<li>dan ${parsed.errors.length - maxShown} lainnya...</li>` : '';

                this.$swal({
                    icon: 'warning',
                    title: 'Import dibatalkan',
                    html: `<div class="text-start small">Perbaiki data berikut lalu import ulang:<ul class="mt-2 mb-0">${list}${more}</ul></div>`,
                });
                return;
            }

            if (parsed.updates.length === 0) {
                this.$swal({
                    icon: 'warning',
                    title: 'Ups!',
                    text: 'Tidak ada nilai yang bisa diimpor. Pastikan kolom semester sudah diisi.',
                });
                return;
            }

            // Ganti objek utuh supaya Vue mendeteksi perubahan nilai.
            let subjectList = JSON.parse(JSON.stringify(this.form.subject_list));
            let totalScore = 0;
            let totalOff = 0;

            parsed.updates.forEach(item => {
                if (subjectList[item.semester] === undefined) {
                    subjectList[item.semester] = {};
                }

                if (subjectList[item.semester][item.id] === undefined) {
                    subjectList[item.semester][item.id] = { id: item.id, score: '', active: '0' };
                }

                let entry = subjectList[item.semester][item.id];

                if (item.off) {
                    if (this.isSubjectActive(entry)) {
                        totalOff++;
                    }
                    entry.active = '0';
                } else {
                    entry.score = String(item.score);
                    entry.active = '1';
                    totalScore++;
                }
            });
            this.form.subject_list = subjectList;

            let successText = `${totalScore} nilai berhasil diimpor dan disimpan!`;
            if (totalOff > 0) {
                successText += ` (${totalOff} mata pelajaran di-Off-kan karena diisi "-")`;
            }

            this.submitScore(false, {
                successText : successText,
                failureHint : 'Nilai dari file sudah dimasukkan ke form. Lengkapi nilai yang masih kosong lalu klik Simpan Nilai Semester.'
            });
        },
        parseImportWorkbook: function(XLSX, workbook) {
            let errors  = [];
            let updates = [];

            let worksheet = workbook.Sheets['Nilai Rapor'] || workbook.Sheets[workbook.SheetNames[0]];
            let rows = worksheet ? XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: '', blankrows: false }) : [];
            let header = (rows[0] || []).map(cell => String(cell).trim().toLowerCase());
            let idCol = header.indexOf('id');

            // Cari posisi kolom tiap semester dari header.
            let semesterCols = [];
            this.getSemesterList().forEach(semester => {
                let col = header.indexOf(this.getSemesterColumnName(semester).toLowerCase());

                if (col !== -1) {
                    semesterCols.push({ semester, col });
                }
            });

            if (idCol === -1 || semesterCols.length === 0) {
                errors.push('Kolom ID / Semester tidak ditemukan. Gunakan file format yang sudah di-download.');
                return { errors, updates };
            }

            let subjectNames = {};
            this.dataSubject.forEach(subject => {
                subjectNames[subject.id] = subject.name;
            });

            rows.slice(1).forEach((row, index) => {
                let id = String(row[idCol]).trim();
                let rowNumber = index + 2;

                if (id === '') {
                    return;
                }

                if (subjectNames[id] === undefined) {
                    errors.push(`Baris ${rowNumber}: mata pelajaran tidak dikenali`);
                    return;
                }

                semesterCols.forEach(({ semester, col }) => {
                    let raw = row[col];
                    let text = String(raw).trim();

                    // Kosong = tidak diubah.
                    if (text === '') {
                        return;
                    }

                    // "-" = switch OFF.
                    if (text === '-') {
                        updates.push({ semester, id, off: true });
                        return;
                    }

                    let columnName = this.getSemesterColumnName(semester);
                    let score = typeof raw === 'number' ? raw : Number(text.replace(',', '.'));

                    if (!isFinite(score) || score < 0 || score > 100) {
                        errors.push(`${subjectNames[id]} (${columnName}): nilai "${raw}" tidak valid (harus angka 0-100)`);
                        return;
                    }

                    updates.push({ semester, id, score: Math.round(score * 100) / 100 });
                });
            });

            return { errors, updates };
        },
        saveScore: function() {
            this.submitScore(this.isTkaActive);
        },
        submitScore: function(isTka, options = {}) {
            this.fetch_save_score = true;
            let formData = new FormData();
            formData.append('rationalization_id', this.$parent.dataRationalization.id);
            formData.append('code', this.$parent.dataRationalization.code);
            formData.append('major_one', this.$parent.dataRationalization.major_one.id);
            formData.append('major_one_name', this.$parent.dataRationalization.major_one.name);
            formData.append('major_one_group', this.$parent.dataRationalization.major_one.group_subject_id);
            formData.append('major_two', this.$parent.dataRationalization.major_two.id);
            formData.append('major_two_name', this.$parent.dataRationalization.major_two.name);
            formData.append('major_two_group', this.$parent.dataRationalization.major_two.group_subject_id);

            formData.append('id', this.form.id);
            formData.append('total_semester', this.form.total_semester);
            formData.append('score_passing_grade', this.form.score_passing_grade);
            formData.append('generate', this.form.generate);

            if (isTka) {
                formData.append('score_tka_list', JSON.stringify(this.form.score_tka_list));
            } else {
                formData.append('subject_list', JSON.stringify(this.form.subject_list));
            }

            let endpoint = isTka ? 'rationalization/save-score-tka' : 'rationalization/save-score';

            this.$http.post(process.env.VUE_APP_APIHOST + endpoint, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(response => {
                this.fetch_save_score = false;

                if (response.data.status) {
                    this.$swal({
                        icon: 'success',
                        title: 'Success',
                        text: options.successText || response.data.message,
                        confirmButtonText: 'OK'
                    }).then((result) => {
                        if (result.value) {
                            this.form.generate = response.data.generate;

                            this.$parent.getDataByCode(response.data.code);
                            this.$parent.getStep();
                        }
                    });
                } else {
                    let text = response.data.message;
                    if (options.failureHint) {
                        text += ' ' + options.failureHint;
                    }

                    this.$swal({
                        icon: 'warning',
                        title: 'Ups!',
                        text: text,
                    });
                }
                this.waiting = false;
            })
            .catch(() => {
                this.fetch_save_score = false;
                this.$swal({
                    icon: 'warning',
                    title: 'Ups!',
                    text: 'Please check your internet connection.',
                });
                this.waiting = false;
            });
        },
        onSubmit: function () {
            this.waiting    = true;
            this.submitted  = true;

            let formData = new FormData();

            formData.append('rationalization_id', this.$parent.dataRationalization.id);
            formData.append('code', this.$parent.dataRationalization.code);
            formData.append('tab_active', this.$parent.tabActive);

            this.$http.post(process.env.VUE_APP_APIHOST + 'rationalization/save-steps', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(response => {
                    if (response.data.status) {
                        this.$swal({
                            icon: 'success',
                            title: 'Success',
                            text: response.data.message,
                            confirmButtonText: 'OK'
                        }).then((result) => {
                            if (result.value) {
                                // Pindah ke halaman edit hanya kalau belum di sana.
                                // form.id bisa masih kosong di halaman edit (getData tidak
                                // dipanggil kalau nilai belum pernah diisi).
                                if(this.$route.params.code !== response.data.code) {
                                    this.$router.push({
                                        name : 'rationalization_form_edit',
                                        params: { code: response.data.code }
                                    });
                                }

                                this.$parent.getDataByCode(response.data.code);
                                this.$parent.getStep();
                            }
                        });
                    } else {
                        this.$swal({
                            icon: 'warning',
                            title: 'Ups!',
                            text: response.data.message,
                        });
                    }
                    this.waiting = false;
                })
            .catch(function () {
                this.$swal({
                    icon: 'warning',
                    title: 'Ups!',
                    text: 'Please check your internet connection.',
                });
                this.waiting = false;
                return;
            });
        }
    },
}
</script>